export enum Salutation {
	Female = 1,
	Male = 2,
}